import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Footer from "../component/Footer";
import About from "../pages/About";
import Service from "../pages/Service/Service";
import SinglePost from "../pages/casestudies/SinglePost";
import NetworkPenetrationTesting from "../pages/Service/NetworkPenetrationTesting";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Contact from "../pages/Contact";
import WebApplicationPenetrationTesting from '../pages/Service/WebApplicationPenetrationTesting';
import VulnerabilityAssessment from '../pages/Service/VulnerabilityAssessment';
import MobileAppPenetration from '../pages/Service/MobileAppPenetration';
import ApiPenetration from '../pages/Service/ApiPenetration';
import ISO27001Consulting from '../pages/Service/ISO27001Consulting';
import SIAConsulting from '../pages/Service/SIAConsulting';
import ADHICSCompliance from '../pages/Service/ADHICSCompliance';
import UAEInformation from '../pages/Service/UAEInformation';
import ManagedSecurity from '../pages/Service/ManagedSecurity';
import SecurityOperation from '../pages/Service/SecurityOperation';
import SDLCConsulting from '../pages/Service/SDLC';
import Hardening from '../pages/Service/Hardning';
import AccessControl from '../pages/Service/AccessControl';

import HeaderNavbar from "../component/HeaderNavbar";
import AnnualSecurity from "../pages/Service/AnnualSecurity";
import OpenSource from "../pages/Service/OpenSource";
import NotFound from "../pages/NotFound";

export default function Router() {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer); // Cleanup function to clear the timer
    }, []);
    const [headerData, setHeaderData] = useState([]);
    // const [popularData, setPopularData] = useState([]);
    // const [filters, setFilters] = useState({ dest: [], exp: [], who: [], month: [] });
    // const [isVcard, setIsVcard] = useState(false);

    return (
        <>
            <BrowserRouter>

                {/* <Header setHeaderData={setHeaderData} /> */}
                <HeaderNavbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Service />} />
                    <Route path="/services/network-penertration" element={<NetworkPenetrationTesting />} />
                    <Route path="/services/web-application-penetration" element={<WebApplicationPenetrationTesting />} />
                    <Route path="/services/vulnerability-assessment" element={<VulnerabilityAssessment />} />
                    <Route path="/services/api-penetration" element={<ApiPenetration />} />
                    <Route path="/services/mobile-app" element={<MobileAppPenetration />} />
                    <Route path="/services/iso-27001" element={<ISO27001Consulting />} />
                    <Route path="/services/sia-consulting" element={<SIAConsulting />} />
                    <Route path="/services/adhics-compliance" element={<ADHICSCompliance />} />
                    <Route path="/services/uae-information" element={<UAEInformation />} />
                    <Route path="/services/managed-security" element={<ManagedSecurity />} />
                    <Route path="/services/security-operations" element={<SecurityOperation />} />
                    <Route path="/services/annual-security" element={<AnnualSecurity />} />
                    <Route path="/services/sdlc-contulting" element={<SDLCConsulting />} />
                    <Route path="/services/server-hardening" element={<Hardening />} />
                    <Route path="/services/access-control" element={<AccessControl />} />
                    <Route path="/services/open-source" element={<OpenSource />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/contact-us" element={<Contact />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer headerData={headerData} />
            </BrowserRouter >
        </>
    );
}